import { render, staticRenderFns } from "./ZDMFailure.vue?vue&type=template&id=3556105d&scoped=true&"
import script from "./ZDMFailure.vue?vue&type=script&lang=js&"
export * from "./ZDMFailure.vue?vue&type=script&lang=js&"
import style0 from "./ZDMFailure.vue?vue&type=style&index=0&id=3556105d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556105d",
  null
  
)

export default component.exports